export const ostomyPrivacyTitles = [
  ["구분", "항목", "기간"],
  ["근거법령", "보존항목", "보존기간"],
  ["제공 받는자", "제공 목적", "제공 정보"]
];
export const ostomyPrivacyRows = [
  [
    [
      "회사 내부 정책\n(부정거래의 배제 등 회사 방침에 의한 보존)",
      "아이디, DI\n(Duplication Information)",
      "회원탈퇴 후 1년",
    ]
  ],
  [
    [
      "신용정보의 이용 및 보호에 관한 법률",
      "신용정보의 수집/처리 및 이용 등에 관한 기록",
      "3년",
    ],
    [
      "통신비밀보호법",
      "서비스 방문 기록",
      "3개월",
    ]
  ],
  [
    [
      "병원회원",
      "비대면 진료 및 건강관리 서비스 제공",
      "성명름, 주민등록번호, 휴대폰번호, 자녀이름, 자녀 주민등록번호, 사전문진 정보, 증상사진 등 참고자료, 내외국인 여부, 개인위치정보(경도, 위도), 처방전 등 진료 후 정보"
    ]
  ],
]
export const ostomySpecialTitles = [
  "구분", "처리항목", "처리목적"
]
export const ostomySpecialRows = [
  [
      "서비스 이용 시 자동 생성되는 정보",
      "서비스 이용 기록, 접속 로그, 쿠키, 접속IP 주소, 기기고유번호(등록번호, 디바이스 아이디 또는 IMEI), 불량 이용 기록, 광고식별자, 사용 이동통신사",
      "서비스/상품 이용 정보 통계 및 분석"
  ],
  [
    "병원/약국 찾기 서비스 이용 시",
    "개인위치정보(경도, 위도)",
    "병원찾기 서비스 제공",
  ],
  [
    "병원/약국 찾기 서비스 이용 시이벤트 응모 및 상담신청",
    "개인위치정보(경도, 위도)(필수) 이름, 휴대전화번호\n(선택) 성별, 생년월일",
    "병원찾기 서비스 제공이벤트 및 혜택 알림 정보 등 마케팅 ∙ 광고 활용, 서비스/신상품이나 이벤트 정보 안내, 이벤트 경품 배송",
  ],
  [
    "이벤트 응모 및 상담신청",
    "(필수) 이름, 휴대전화번호\n(선택) 성별, 생년월일",
    "이벤트 및 혜택 알림 정보 등 마케팅 ∙ 광고 활용, 서비스/신상품이나 이벤트 정보 안내, 이벤트 경품 배송",
  ],
  [
    "재외국민 비대면진료 서비스",
    "여권번호, 휴대폰번호",
    "재외국민 본인 인증",
  ]
]